import {UserInfo} from "./UserInfo";
import {AccessStatusEnum, AccessStatusHelper} from "./AccessStatus";
import {UserService} from "../providers/user-service";
import {Events} from "ionic-angular";

export class UserInfoSingleton{
  private static _instance: UserInfoSingleton;

  private _info: UserInfo;

  private _refreshTimeout: any;

  private readonly _refreshSeconds: number = 30;

  private _accessStatusCode: string = null;

  public constructor(
    private usrsrv: UserService,
    private events: Events
  ){
    if(UserInfoSingleton._instance){
      UserInfoSingleton._instance.init();
      return UserInfoSingleton._instance;
    }
    UserInfoSingleton._instance = this;

    this.init();
  }

  public static get instance(): UserInfoSingleton{
    if(!UserInfoSingleton._instance){
      console.log('Instance is null');
    }
    return UserInfoSingleton._instance;
  }

  public get info(): UserInfo{
    return this._info;
  }

  public get active(): boolean{
    return this._info.AccessStatus &&
      (AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Active
        || AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Trial);
  }

  public isactive(): boolean{
    return this._info.AccessStatus &&
      (AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Active
        || AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Trial);
  }

  public get blocked(): boolean{
    return !this._info.AccessStatus ||
      (AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Suspended
        || AccessStatusHelper.statusCodeToEnum(this._info.AccessStatus.Code) === AccessStatusEnum.Blocked);
  }


  public clear(){
    if(this._refreshTimeout){
      clearTimeout(this._refreshTimeout);
      this._refreshTimeout = null;
    }
    this._info = null;
  }

  private init(){
    console.log("Init singleton");
      this.refreshInfo();
  }

  public update(){
    this.refreshInfo();
  }

  private refreshInfo(){
    this.usrsrv.getInfo().subscribe(
      (data) => {
        this._info = data ? data.user : null;

        if(this._info && this._info.AccessStatus){

          if(this._accessStatusCode !== null && this._accessStatusCode !== this._info.AccessStatus.Code){
            // AS: access code has been changed
            this.events.publish("user:access-status-changed", this._info.AccessStatus.Code);
          }
          else if(this._accessStatusCode === null){
            // AS: при первой загрузке проинициализировали статус пользователя
            this.events.publish("user:access-status-initialized", this._info.AccessStatus.Code);
          }

          this._accessStatusCode = this._info.AccessStatus.Code;
        }

        this._refreshTimeout = setTimeout(() => {
          this.refreshInfo()
        }, this._refreshSeconds * 1000);
      },
      (err) => {
        console.log(err);
        this._refreshTimeout = setTimeout(() => {
          this.refreshInfo()
        }, this._refreshSeconds * 1000);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/UserInfoSingleton.ts